import { render, staticRenderFns } from "./NumberExercisesTendency.vue?vue&type=template&id=176b1f92&scoped=true&"
import script from "./NumberExercisesTendency.vue?vue&type=script&lang=js&"
export * from "./NumberExercisesTendency.vue?vue&type=script&lang=js&"
import style0 from "./NumberExercisesTendency.vue?vue&type=style&index=0&id=176b1f92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176b1f92",
  null
  
)

export default component.exports